import React from 'react';
import { ImportBatchesList } from './ImportBatchesList';

interface ImportBatchesOffCanvasProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ImportBatchesOffCanvas: React.FC<ImportBatchesOffCanvasProps> = ({ isOpen, onClose }) => {
  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/30 z-40 transition-opacity"
          onClick={onClose}
        />
      )}

      {/* OffCanvas */}
      <div
        className={`fixed top-0 right-0 h-full w-full min-[1534px]:w-[600px] bg-white dark:bg-gray-800 shadow-2xl z-50 transition-transform duration-300 ease-in-out overflow-y-auto ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        {/* Header */}
        <div className="sticky top-0 bg-gradient-to-r from-blue-600 to-blue-700 px-6 py-6 border-b border-blue-800 flex items-center justify-between">
          <div>
            <h2 className="text-xl font-bold text-white">Historique des imports CSV</h2>
            <p className="text-blue-100 text-sm mt-1">Gérez vos fichiers importés</p>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-blue-500 rounded-lg transition-colors"
          >
            <svg
              className="w-6 h-6 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <ImportBatchesList />
        </div>
      </div>
    </>
  );
};
